import './EmbeddedYoutubeVideo.css';
import { CmsMeta } from '../cms/cmsMeta';

type EmbeddedYoutubeVideoProps = {
	videoId: string;
	/** playback position in seconds */
	start?: number;
	/** the privacy-enhanced player, when the link asked for it */
	nocookie?: boolean;
};
export const EmbeddedYoutubeVideo = ({ videoId, start, nocookie }: EmbeddedYoutubeVideoProps) => {
	const host = nocookie ? 'www.youtube-nocookie.com' : 'www.youtube.com';
	return (
		<div className="video-container">
			<iframe
				src={`https://${host}/embed/${videoId}${start ? `?start=${start}` : ''}`}
				frameBorder="0"
				loading="lazy"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
				allowFullScreen
				title="YouTube video"
			></iframe>
		</div>
	);
};

export const cmsMeta: CmsMeta = {
	description:
		"A YouTube video in the page. `videoId` is the id from the video's url, the part after watch?v=; `start` is where to begin, in seconds; `nocookie` uses YouTube's privacy-enhanced player.",
	example: [
		'EmbeddedYoutubeVideo',
		{
			videoId: 'Fk3kmaFYKbw',
		},
	],
};
